import React, { Component } from 'react'

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableFooter } from 'material-ui/Table';
import Pagination from 'react-js-pagination';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import Box from '../ui/Box';

import NewRemote from './NewRemote';

//providers
import DataService from '../../services/DataService'; var ds = DataService;
import LocalStorageService from '../../services/LocalStorageService'; var ls = LocalStorageService;
import Helper from '../../services/Helper'; var help = Helper;

export default class AllRemotes extends Component {

  constructor(props) {
    super(props);
    this.state = {
      all_remotes: [],
      current_offset: 0,
      activePage: 1,
      totalCount: 0,
      maxItems: 20,
      room_id: this.props.room_main_id,
      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    }
    // this.searchColumnWise = this.searchColumnWise.bind(this);
  }

  maxItems = 7;
  componentDidMount() {
    this.getAllRemotes(this.state.current_offset);
    window.addEventListener('updateRemotesTable', (e) => {
      if (e.detail && e.detail == true) {
        this.refreshTable();
      }
    });
  }

  onChangePage(e) {
    this.getAllRemotes(this.maxItems * (e - 1));
    this.setState({
      activePage: e
    })
  }

  getAllRemotes(offset, offset_change = 0) {
    ds.getRoomRemotes(this.state.room_id,
      data => {
        this.setState({
          all_remotes: data.appliances
        });

        if (!offset_change) {
          let x = this.state.current_offset;
          this.setState({
            current_offset: offset + this.maxItems
          })
        }
      }, err => {
        console.log(err);
      }
    );
  }

  refreshTable(e) {
    this.getAllRemotes(this.state.current_offset - this.maxItems > 0 ? this.state.current_offset - this.maxItems : 0, 1);
  }

  closeDialog(refresh = 0) {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    })
    if (refresh) {
      this.getAllRemotes(0);
    }
  }

  editRemote(row, e) {
    this.setState({
      dialog: {
        open: true,
        body: <NewRemote details={row} unMountMe={this.closeDialog.bind(this)} room_main_id={this.state.room_id} />,
        actions: []
      }
    });
  }

  deleteRemote(row, e) {
    this.setState({
      dialog: {
        open: true,
        head: 'Delete',
        body: 'Delete Remote permanently?',
        actions: [
          <FlatButton
            label="Delete"
            primary
            onClick={() => {
              ds.postDeleteRemote({ id: row._id },
                data => {
                  let x = this.state.current_offset - this.state.maxItems;
                  this.closeDialog();
                  this.getAllRemotes(x > 0 ? x : 0, 1);
                }, err => {
                  console.log(err);
                });
            }}
          />,
          <FlatButton
            label="Cancel"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    });
  }

  render() {
    let pagination;
    pagination = <Pagination
      activePage={this.state.activePage}
      itemsCountPerPage={this.maxItems}
      totalItemsCount={this.state.totalCount}
      pageRangeDisplayed={5}
      onChange={this.onChangePage.bind(this)} 
    />
    return (
      <div>
        <Box header='Remotes List'>
          <Dialog
            title={this.state.dialog.head}
            actions={this.state.dialog.actions}
            modal={false}
            open={this.state.dialog.open}
            onRequestClose={this.closeDialog.bind(this)}
            autoScrollBodyContent={true}
          >
            {this.state.dialog.body || 'NA'}
          </Dialog>

          <Table
            height={'30vh'}
            fixedHeader={true}
            fixedFooter={true}
            selectable={false}
            multiSelectable={false}
            bodyStyle={{ minWidth: 680, overflowX: 'auto' }}
          >
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn tooltip="Name">Name</TableHeaderColumn>
                <TableHeaderColumn tooltip="Type">Type</TableHeaderColumn>
                <TableHeaderColumn tooltip="Brand">Brand</TableHeaderColumn>
                <TableHeaderColumn tooltip="Options">Options</TableHeaderColumn>
              </TableRow>
            </TableHeader>

            <TableBody
              displayRowCheckbox={false}
              showRowHover={true}
              stripedRows={false}
            >
              {
                this.state.all_remotes.map((row, index) => (
                  <TableRow key={index}>
                    <TableRowColumn>{row.name}</TableRowColumn>
                    <TableRowColumn>{row.type}</TableRowColumn>
                    <TableRowColumn>{row.brand}</TableRowColumn>
                    <TableRowColumn>
                      <i className="material-icons link-fg"
                        style={{cursor:'pointer'}}
                        onClick={this.editRemote.bind(this, row)}
                      >
                        mode_edit
                      </i>

                      <i className="space"></i>

                      <i className="material-icons warn-fg"
                        style={{cursor:'pointer'}}
                        onClick={this.deleteRemote.bind(this, row)}
                      >
                        delete
                      </i>
                    </TableRowColumn>
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
        </Box>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./components/remotes/AllRemotes.js